module.exports = __webpack_public_path__ + "static/media/S (58).f874792b.jpg";